import { render, staticRenderFns } from "./bdcx.vue?vue&type=template&id=bd3b5e84&"
import script from "./bdcx.vue?vue&type=script&lang=js&"
export * from "./bdcx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports